import store from "../store/userStore";
import _, { set, get } from "lodash";
import constants from "@/utils/constants.js";
import moment from "moment";
import CryptoJS from 'crypto-js';

const dummyOptions = [
  {
      index: constants.OPTIONS_ABC[0],
      option_text: constants.DUMMYTEXT,
      correct_answer: true,
  },
  {
      index: constants.OPTIONS_ABC[1],
      option_text: constants.DUMMYTEXT,
      correct_answer: false,
  },
  {
      index: constants.OPTIONS_ABC[2],
      option_text: constants.DUMMYTEXT,
      correct_answer: false,
  },
  {
      index: constants.OPTIONS_ABC[3],
      option_text: constants.DUMMYTEXT,
      correct_answer: false,
  },
];
const dummyOptionsABC = [
  {
      index: constants.OPTIONS_ABC[0],
      option_text: constants.DUMMYTEXT,
      column: 1,
      correct_answer: "P",
  },
  {
      index: constants.OPTIONS_ABC[1],
      option_text: constants.DUMMYTEXT,
      column: 1,
      correct_answer: "P",
  },
];
const dummyOptionsPQR = [
  {
      index: constants.OPTIONS_PQR[0],
      option_text: constants.DUMMYTEXT,
      column: 2,
      correct_answer: "",
  },
  {
      index: constants.OPTIONS_PQR[1],
      option_text: constants.DUMMYTEXT,
      column: 2,
      correct_answer: "",
  },
];

function getInstituteLogo() {
  const myInstitute = get(store, "state.myInstitute");
  if (myInstitute && myInstitute.logo_url) {
    return myInstitute.logo_url;
  }

  return require("@/assets/img/Eduracle_Logo.png");
}

function getInstituteMobileLogo() {
  
  return require("@/assets/img/small_logo.png");
}

function checkIsDefaultInstitute() {
  const myInstitute = get(store, "state.myInstitute");

  if (myInstitute && myInstitute.subdomain) {
    for (const customDomain of constants.CUSTOM_DOMAINS) {
      if (myInstitute.subdomain.includes(customDomain)) {
        return false;
      }
    }
  }
  return true;
}

function setPageTitle(isDefaultInstitute) {
  let institute = JSON.parse(localStorage.getItem("myInstitute"));
  let title=null;
  if(institute && institute.subdomain){
     title = institute.subdomain.replace("https://", "").split(".");
  }
  if(title && title.length){
    title =institute.is_white_labeled?constants.DEFAULT_TITLE_TESTING + title[0].charAt(0).toUpperCase() +
    title[0].replace(title[0][0], ""):
    constants.DEFAULT_TITLE +title[0].charAt(0).toUpperCase() +
    title[0].replace(title[0][0], "");
  }
  const favicon = document.getElementById("pageFavIcon");
  if (isDefaultInstitute) {
    favicon.href = institute.is_white_labeled? require("@/assets/img/svg/testing.svg"):process.env.BASE_URL + "favicon.ico";
    document.title = title;
  } else {
    
    favicon.href =institute.id === constants.ONLINE_INSTITUTE_ID ? institute.is_white_labeled? require("@/assets/img/svg/testing.svg"):process.env.BASE_URL + "favicon.ico" : process.env.BASE_URL +constants.FAVICON[institute.id];
    document.title = institute.id === constants.ONLINE_INSTITUTE_ID ? title:constants.PAGE_TITLE[institute.id];
  }
}

function isValidMobileNumber(mobile) {
  if (mobile.match(/^[0-9]{10}$/)) {
    return true;
  }
  return false;
}
function getMobileNumberWithCountryCode(code, phone) {
  if (code) {
    return code + "-" + phone;
  } else {
    return phone;
  }
}
function getMobileNumberWithoutCountryCode(phone) {
  if (phone) {
    let mobDetails = phone.split("-");
    if (mobDetails && mobDetails.length > 1) {
      return { countryCode: mobDetails[0], number: mobDetails[1] };
    } else {
      return { number: phone, countryCode: "" };
    }
  } else {
    return { number: "", countryCode: "" };
  }
}
function isValidEmail(value) {
  let lastAtPos = value.lastIndexOf('@');
  let lastDotPos = value.lastIndexOf('.');
   let valid = false 
  if (!(lastAtPos < lastDotPos && lastAtPos > 0 && value.indexOf('@@') === -1 && lastDotPos > 2 && (value.length - lastDotPos) > 2 && (value.length - lastDotPos) < 5 )) {
   valid = false;
  }
  else if(value && value.trim().length > 150){
    valid = false;
  }
  let re = /^(([^<>()\[\]\\.,;:\s@%!#$^&*\"\'?/,\-"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(value)) {
    valid =true;
  }
  if (value.charAt(0) === '+') {
    valid=false
  }
  return valid;
}

function dataURItoBlob(dataURI, callback) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does constants
  var byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI
    .split(",")[0]
    .split(":")[1]
    .split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var bb = new Blob([ab]);
  return bb;
}

function getTelegramLink(user) {
  const isDefaultInstitute = this.checkIsDefaultInstitute();
  const myInstitute = get(store, "state.myInstitute");

  let botName = isDefaultInstitute ? "TryEduracleBot" : "TryAltitudeBot";
  if (process.env.NODE_ENV.toLowerCase() == "production") {
    botName = isDefaultInstitute ? "EduracleBot" : "AltitudeBot";
  }
  if (myInstitute && myInstitute.is_white_labeled) {
    botName = 'TestingPlatformInBot'
  }
  return `https://telegram.me/${botName}?start=${user.telegram_token}`;
}

function validation(req) {
  // return;
  // let req = this.selectedQuestion;
  let valid = true;
  if (!req.chapterId) {
    this.$toasted.error("Please select chapter", { icon: "info" });
    valid = false;
  } else if (
    !req.question_text ||
    this.extractContent(req.question_text, true).trim() === ""
  ) {
    this.$toasted.error(
      req.questionType.id === this.QUE_TYPES.COMPREHENSION ||
        req.questionType.id === this.QUE_TYPES.TC
        ? "Please enter passage"
        : "Please enter question",
      { icon: "info" }
    );
    valid = false;
  } else {
    valid = this.validateAsperType(req, valid);
  }
  if (valid) {
    if (!req.correct_answer && req.subtype !== this.QUE_TYPES.COMPREHENSION_2Q_NU) {
      if (
        req.questionType.id === this.QUE_TYPES.INTEGER ||
        req.questionType.id === this.QUE_TYPES.SUBJECTIVE ||
        req.questionType.id === this.QUE_TYPES.SUBJECTIVEINTEGER
      ) {
        this.$toasted.error("Please enter answer", { icon: "info" });
        valid = false;
      } else if (req.questionType.id != this.QUE_TYPES.MATRIX_MATCH) {
        this.$toasted.error("Choose the correct option", { icon: "info" });
        valid = false;
      }
    } else {
      if (req.questionType.id === this.QUE_TYPES.INTEGER) {
        const re = /^-?[0-9\b]+$/;
        if (!re.test(req.correct_answer)) {
          this.$toasted.error("Answer value must be integer", { icon: "info" });
          valid = false;
        }
      } else if (req.questionType.id === this.QUE_TYPES.SUBJECTIVE || req.questionType.id === this.QUE_TYPES.SUBJECTIVEINTEGER) {
        let subjectiveValues = req.correct_answer.split("##");
        if (!subjectiveValues[0] || subjectiveValues[0].length < 1) {
          this.$toasted.error("Please enter a valid start value", {
            icon: "info",
          });
          valid = false;
        } else if (!subjectiveValues[1] || subjectiveValues[1].length < 1) {
          this.$toasted.error("Please enter a valid end value", {
            icon: "info",
          });
          valid = false;
        } else if (
          req.questionType.id === this.QUE_TYPES.SUBJECTIVE &&
          parseFloat(subjectiveValues[0]) > parseFloat(subjectiveValues[1])
        ) {
          this.$toasted.error(
            "Start value must be less than or equal to end value",
            { icon: "info" }
          );
          valid = false;
        }
        else if (
          req.questionType.id === this.QUE_TYPES.SUBJECTIVEINTEGER 
        ) {
          if (!Number.isInteger(parseFloat(subjectiveValues[0]))) {
            this.$toasted.error("Start value should be of integer type", {
              icon: "info",
            });
            valid = false;
          }else if (!Number.isInteger(parseFloat(subjectiveValues[1]))) {
            this.$toasted.error("End value should be of integer type", {
              icon: "info",
            });
            valid = false;
          }else if(parseFloat(subjectiveValues[0]) !== parseFloat(subjectiveValues[1])){

            this.$toasted.error(
              "Start value must be equal to end value",
              { icon: "info" }
            );
            valid = false;
          }
        }
      }
    }
  }
  return valid;
}

function validateAsperType(req, valid) {
  if (
    req.questionType.id === this.QUE_TYPES.ASSERTION_REASON ||
    req.questionType.id === this.QUE_TYPES.MULTIPLE_CORRECT ||
    req.questionType.id === this.QUE_TYPES.SINGLE_CORRECT ||
    req.questionType.id === this.QUE_TYPES.SINGLE_CORRECT_SEC2
  ) {
    if (req.options) {
      let isOptSelected = false;
      for (let idx = 0; idx < req.options.length; idx++) {
        const opt = req.options[idx];
        if (
          !opt.option_text ||
          this.extractContent(opt.option_text, true).trim() === ""
        ) {
          this.$toasted.error("Please enter options", { icon: "info" });
          valid = false;
          break;
        }
        if (opt.correct_answer && opt.correct_answer != "0") {
          isOptSelected = true;
          req.correct_answer = opt.option_text;
        }
      }
      if (!isOptSelected) {
        this.$toasted.error("Please choose correct option.", { icon: "info" });
        valid = false;
      }
    } else {
      this.$toasted.error("Please enter options", { icon: "info" });
      valid = false;
    }
  } else if (
    req.questionType.id === this.QUE_TYPES.COMPREHENSION ||
    req.questionType.id === this.QUE_TYPES.TC
  ) {
    for (let idx = 0; idx < req.questions.length; idx++) {
      const question = req.questions[idx];
      if (this.extractContent(question.question_text, true).trim() === "") {
        this.$toasted.error("Please enter question " + (idx + 1), {
          icon: "info",
        });
        valid = false;
        break;
      }
      let isOptSelected = false;
      if (req.subtype !== this.QUE_TYPES.COMPREHENSION_2Q_NU) {
        for (let ind = 0; ind < question.options.length; ind++) {
          const opt = question.options[ind];
          if (
            !opt.option_text ||
            this.extractContent(opt.option_text, true).trim() === ""
          ) {
            this.$toasted.error(
              "Please enter options for question" + (idx + 1),
              {
                icon: "info",
              }
            );
            valid = false;
            return valid;
          }

          if (opt.correct_answer) {
            isOptSelected = true;
            req.correct_answer = opt.option_text;
          }
        }
        if (!isOptSelected) {
          this.$toasted.error(
            "Please choose correct options for question" + (idx + 1),
            { icon: "info" }
          );
          valid = false;
          break;
        }
      } else {
        let subjectiveValues = question && question.correct_answer ? question.correct_answer.split("##") : '';
        if (!subjectiveValues[0] || subjectiveValues[0].length < 1) {
          this.$toasted.error("Please enter a valid start value", {
            icon: "info",
          });
          valid = false;
        } else if (!subjectiveValues[1] || subjectiveValues[1].length < 1) {
          this.$toasted.error("Please enter a valid end value", {
            icon: "info",
          });
          valid = false;
        } else if (
          parseFloat(subjectiveValues[0]) > parseFloat(subjectiveValues[1])
        ) {
          this.$toasted.error(
            "Start value must be less than or equal to end value",
            { icon: "info" }
          );
          valid = false;
        }
      }
    }
  } else if (
    req.questionType.id === this.QUE_TYPES.MATRIX_MATCH &&
    req.options_abc &&
    req.options_pqr
  ) {
    for (let idx = 0; idx < req.options_abc.length; idx++) {
      const opt = req.options_abc[idx];
      if (
        !opt.option_text ||
        this.extractContent(opt.option_text, true).trim() === ""
      ) {
        this.$toasted.error("Please enter options from column 1", {
          icon: "info",
        });
        valid = false;
        break;
      }
      if (!opt.correct_answer || opt.correct_answer == "") {
        this.$toasted.error("Please choose correct option for " + opt.index, {
          icon: "info",
        });
        valid = false;
        break;
      }
      if (opt.correct_answer) {
        req.correct_answer = "-";
      }
    }
    for (let idx = 0; idx < req.options_pqr.length; idx++) {
      const opt = req.options_pqr[idx];
      if (
        !opt.option_text ||
        this.extractContent(opt.option_text, true).trim() === ""
      ) {
        this.$toasted.error("Please enter options from column 2", {
          icon: "info",
        });
        valid = false;
        break;
      }
    }
  } else if (
    req.questionType.id === this.QUE_TYPES.MATRIX_MATCH_OPTION &&
    req.options_abc &&
    req.options_pqr
  ) {
    for (let idx = 0; idx < req.options_abc.length; idx++) {
      const opt = req.options_abc[idx];
      if (
        !opt.option_text ||
        this.extractContent(opt.option_text, true).trim() === ""
      ) {
        this.$toasted.error("Please enter options from column 1", {
          icon: "info",
        });
        valid = false;
        return valid;
        break;
      }
    }
    for (let idx = 0; idx < req.options_pqr.length; idx++) {
      const opt = req.options_pqr[idx];
      if (
        !opt.option_text ||
        this.extractContent(opt.option_text, true).trim() === ""
      ) {
        this.$toasted.error("Please enter options from column 2", {
          icon: "info",
        });
        valid = false;
        return valid;
        break;
      }
    }
    for (let idx = 0; idx < req.options.length; idx++) {
      const opt = req.options[idx];
      if (
        !opt.option_text ||
        this.extractContent(opt.option_text, true).trim() === ""
      ) {
        this.$toasted.error("Please enter options", { icon: "info" });
        valid = false;
        break;
      }
      if (opt.correct_answer) {
        {
          req.correct_answer = opt.option_text;
        }
      }
    }
  }
  return valid;
}
function getHintsForRequest(hints) {
  let hintsArr = [];
  for (let idx = 0; idx < hints.length; idx++) {
      let hint = hints[idx];
      if (extractContent(hint.text, true).trim() != "") {
          let h = {
              hint: hint.text,
          };
          if (hint.id) {
              h.id = hint.id;
          }
          hintsArr.push(h);
      }
  }
  return hintsArr;
}
function extractContent(s, isForValidation, space) {
  if (isForValidation && s) {
    s = s.toString();
    s = s.replace(/&nbsp;/g, "");
    s = s.replace(/<p>/g, "");
    s = s.replace(/<\/p>/g, "");
    s = s.replace(/\s/g, "");
    if (s.trim().length < 1) return "";
    else {
      return s;
    }
  }
  var span = document.createElement("span");
  span.innerHTML = s;
  if (space) {
    var children = span.querySelectorAll("*");
    for (var i = 0; i < children.length; i++) {
      if (children[i].textContent) children[i].textContent += " ";
      else children[i].innerText += " ";
    }
  }
  let text = [span.textContent || span.innerText]
    .toString()
    .replace(/^[a-z0-9]+$\i/g, " ")
    .replace(/\r?\n|\r|\t/g, " ")
    .replace(/ +/g, " ")
    .replace(/\s\s+/g, " ");
  return text;
}
function isChecked(opt) {
  if (opt.correct_answer && typeof opt.correct_answer === "boolean") {
    return opt.correct_answer;
  }

  return opt.correct_answer && parseInt(opt.correct_answer);
}
function isCorrect(opt, correctAnswer, isPreview) {
  let check = correctAnswer ? correctAnswer.split(", ") : null;
  if (check && check.length && check.includes(opt.index)) {
    return true;
  }
}
async function renderMath() {
  return new Promise(async(resolve, reject) => {
    if (MathJax) {
      MathJax.Hub.Queue(
        function () {
            // Combine elements from both classes in a single array
            var elements = [...document.getElementsByClassName('equation'), ...document.getElementsByClassName('equation-class')];
            
            if (elements.length > 0) {
                console.log("Total elements: " + elements.length);
                // Queue a single batch typesetting for all elements
                MathJax.Hub.Queue(["Typeset", MathJax.Hub, elements], () => {
                    console.log("All expressions typeset complete");
                    // toast.success('All equations rendered');
                });
            }
        },
        function () {
            // Additional tasks after MathJax completes
            // toast.success('Done');
        }
    );
    } else {
      // reject('MathJax is not loaded');
    }
  });
}
function renderEquation (element) {
  return new Promise((resolve,reject)=>{

    MathJax.Hub.Queue(["Typeset", MathJax.Hub, element], () => {
      console.log("Expression complete");
      // count++;
      resolve()
      // if (count === elements.length) {
      //   resolve();  // Resolve when all elements are processed
      // }
    });
  })

}
function allowedOnlyNumber(evt, onlyPositive) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (!onlyPositive && charCode == 45) {
    return true;
  }
  if (charCode == 46 || charCode == 8 || charCode == 16) {
    return true;
  }
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function allowedOnlyNumberWithDecimal(evt, onlyPositive) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (!onlyPositive && charCode == 45) {
    return true;
  }
  if (charCode == 46 || charCode == 8) {
    return true;
  }
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function generateDayWiseTimeSeries(baseval, count, yrange) {
  var i = 0;
  var series = [];
  while (i < count) {
    var y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push([baseval, y]);
    baseval += 86400000;
    i++;
  }
  return series;
}

function getRouteDetails() {
  let routeDetails = sessionStorage.getItem("routeDetails");
  routeDetails = routeDetails ? JSON.parse(routeDetails) : {};
  return routeDetails;
}
function serializeObject(obj, mainKey) {
  var str = "";
  for (var key in obj) {
    str += "&";
    if (typeof obj[key] !== "object" && !Array.isArray(obj[key]))
      str += (mainKey ? mainKey : key) + "=" + encodeURIComponent(obj[key]);
    else if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
      str += this.serializeObject(obj[key], key);
    } else if (typeof obj[key] === "object" && Array.isArray(obj[key])) {
      obj[key].forEach((element, idx) => {
        let obj = {};
        obj[key + "[" + idx + "]"] = element;
        str += this.serializeObject(obj, key + "[" + idx + "]");
      });
    }
  }
  return str.split("&&").join("&");
}

function getCurrentRouteDetails(rn) {
  let routeDetails = getRouteDetails();
  let crd = {}; // current route details
  if (routeDetails[rn]) crd = routeDetails[rn];
  return crd;
}

function updateCurrentPageInSession(page) {
  let routeName = this.$route.name;
  let crd = getCurrentRouteDetails(routeName);
  if (!crd || !crd.selectedTab || !crd.tabDetails) return;
  if (crd.tabDetails[crd.selectedTab].page)
    crd.tabDetails[crd.selectedTab].page = page;
  else crd.tabDetails[crd.selectedTab] = page;
  setRouteDetails({ routeName, tabDetails: crd.tabDetails });
}

/**
 * routeName
 * selectedTab
 * tabDetails
 * dropdownName
 * searchText
 * isViewed
 *
 */
function setRouteDetails(details) {
  let routeDetails = getRouteDetails();
  if (!routeDetails[details.routeName]) routeDetails[details.routeName] = {};
  if (details.resetRoute) routeDetails[details.routeName] = details;
  else {
    if (details.routeName)
      routeDetails[details.routeName].routeName = details.routeName;
    if (details.hasOwnProperty("selectedTab"))
      routeDetails[details.routeName].selectedTab = details.selectedTab;
    if (details.currentPage)
      routeDetails[details.routeName].currentPage = details.currentPage;
    if (details.tabDetails)
      routeDetails[details.routeName].tabDetails = details.tabDetails;
    if (details.selectedStudent)
      routeDetails[details.routeName].selectedStudent = details.selectedStudent;
    if (details.hasOwnProperty("searchText"))
      routeDetails[details.routeName].searchText = details.searchText;
    if (details.hasOwnProperty("isViewed"))
      routeDetails[details.routeName].isViewed = details.isViewed;
  }
  // console.log('helper: setRouteDetails = ', routeDetails);
  sessionStorage.setItem("routeDetails", JSON.stringify(routeDetails));
}

function isCoordinator() {
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (user && user.role_id === constants.ROLES_ID.CO) {
    return true;
  }
  return false;
}

function checkUserType(role_id) {
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (user && user.role_id === role_id) {
    return true;
  }
  return false;
}
function computedDateFormattedMomentjs(date, format) {
  return date ? moment(date).format(format) : "";
}
function getHeight(appvue) {
  let pageHeight;

  let height = appvue.clientHeight;
  let width = appvue.clientWidth;
  if (width > 667) {
    pageHeight = height;
  } else {
    pageHeight = height - 66;
  }
  return pageHeight;
}
function convertMS(milliseconds) {
  var day, hour, minute, seconds;
  seconds = Math.floor(milliseconds / 1000);
  minute = Math.floor(seconds / 60);
  seconds = seconds % 60;
  hour = Math.floor(minute / 60);
  minute = minute % 60;

  return {
    time: getValue(hour) + ":" + getValue(minute) + ":" + getValue(seconds),
  };
}
function getValue(value) {
  if (value > 9) {
    return value;
  } else {
    return "0" + value;
  }
}
function delayTime(time){
  return new Promise(resolve => setTimeout(resolve, time));
}
function setDivHeight(){
  const stepElem=document.getElementsByClassName("v-stepper");
  const outerElem=document.getElementsByClassName("outer-hg-100");
  const diff=stepElem[0].clientHeight-outerElem[0].clientHeight-110;
  return stepElem[0].clientHeight-diff-168;
}
function checkStudentUpgradedHelper(subscriptionDetails) {
  const user = JSON.parse(sessionStorage.getItem("user"));
  let status = false;
  if(!subscriptionDetails){
    this.$toasted.error(`Subscription Modules Not Found.`, {
      icon: "check_circle",
    });
    return status;
  }
  const subscriptionPkg = subscriptionDetails.find(
    (n) => n.name === "Boost Up"
  );
  if(!subscriptionPkg){
    this.$toasted.error(`Boost Up Module Not Found.`, {
      icon: "check_circle",
    });
    return status;
  }
  if(user.is_free_trail){
    return status;
  } 
  if (
      !(subscriptionPkg.is_subscribed || subscriptionPkg.institute_purchased || subscriptionPkg.is_purchased)
  ) {
      status = true;
  }
  return status;
}
function setEventBeforeUpgrade(event){
  sessionStorage.setItem('event-before-upgrade',event)
}
function removeEvent(event){
  sessionStorage.removeItem('event-before-upgrade')
}
function compareEvent(event){
 return sessionStorage.getItem('event-before-upgrade') === event
}
function removeWhiteSpacesFromEmail(email){
  email = email ? email.replace(/\s+/g, '') : '';
  return email;
}

function createRetryQuestionData(questionList) {
	let list = [];
	// this.$root.showLoader = true;

	questionList.list.map((q, i) => {
		let obj = { ...q };
		if (q.id) {
			obj.id = q.id;
			forUpdate = true;
		}

		obj.dummy_question = {
			index: i+1,
			subIndex: q.subIndex,
			question_text: constants.DUMMYTEXT,
			question_type: q.question_type,
			subType: q.subType,
			solution: constants.DUMMYTEXT,
			options: [],
			data_type_id: q.data_type_id,
			correct_marks: q.correct_marks,
			negative_marks: q.negative_marks,
			partial_marking: q.partial_marking,
			questions: [],
			hints: [{ text: constants.DUMMYTEXT }],
			section_id:
				questionList.optionalQuestionsList.length > 0 ? 2 : 1,
			noOfMandatoryQuestions: q.required_questions,
		};
		obj.dummy_question.hints = getHintsForRequest(
			obj.dummy_question.hints
		);
		obj.dummy_question = setDummyAnswerAsPerType(obj.dummy_question);
		if (
			q.question_type === constants.QUE_TYPES.INTEGER ||
			q.question_type === constants.QUE_TYPES.SUBJECTIVE ||
			q.question_type === constants.QUE_TYPES.SUBJECTIVEINTEGER
		) {
			obj.dummy_question.correct_answer =
				obj.dummy_question.correct_answer;
		} else {
			obj.dummy_question.correct_answer = '-';
		}
		if (
			q.question_type === constants.QUE_TYPES.ASSERTION_REASON ||
			q.question_type === constants.QUE_TYPES.MULTIPLE_CORRECT ||
			q.question_type === constants.QUE_TYPES.SINGLE_CORRECT
		) {
			obj.dummy_question.options = obj.dummy_question.options;
		} else if (q.question_type === constants.QUE_TYPES.MATRIX_MATCH) {
			obj.dummy_question.options = obj.dummy_question.options_abc.concat(
				q.options_pqr
			);
		} else if (q.question_type === constants.QUE_TYPES.MATRIX_MATCH_OPTION) {
			obj.dummy_question.options = obj.dummy_question.options
				.concat(q.options_abc)
				.concat(q.options_pqr);
		}
		list.push(obj);
	});
  return list
}
function setDummyAnswerAsPerType(currentQuestion) {
  // let subQuestionLength = 0;
  // let answerType = 0;
  let questionType = currentQuestion.question_type;
  let subType = currentQuestion.subType ? currentQuestion.subType : currentQuestion.subtype;
  // check if type is comprehension or tc and set the sub questions length
  let {answerType,subQuestionLength} = getAnswerType(
      questionType,
      subType
  );
  let options = null;
  let optionsABC = null;
  let optionsPQR = null;
  switch (answerType) {
      case 0:
          currentQuestion.questions = [];
          for (let i = 0; i < subQuestionLength; i++) {
              // options = _.cloneDeep(dummyOptions);
             if (subType !== constants.QUE_TYPES.COMPREHENSION_2Q_NU) {
    
                  currentQuestion.questions.push({
                      question_text: constants.DUMMYTEXT,
                      options: _.cloneDeep(dummyOptions),
                  });
              }else{
                  currentQuestion.questions.push({
                      question_text: constants.DUMMYTEXT,
                      correct_answer:"0##0",
                  });
              }
          }
          delete currentQuestion['options'];
          break;
      case 1:
          // options = _.cloneDeep(dummyOptions)
          currentQuestion.options = _.cloneDeep(dummyOptions);
          currentQuestion.correct_answer = "0";

          break;

      case 2:
          currentQuestion.options =
              questionType == constants.QUE_TYPES.MATRIX_MATCH_OPTION
                  ? _.cloneDeep(dummyOptions)
                  : [];
          currentQuestion.options_abc = _.cloneDeep(
              dummyOptionsABC
          );
          currentQuestion.options_pqr = _.cloneDeep(
              dummyOptionsPQR
          );
          break;

      case 3:
          // currentQuestion.startValue = "0";
          // currentQuestion.endValue = "0";
          currentQuestion.correct_answer = "0##0";
          break;

      case 4:
          currentQuestion.correct_answer = "0";
          break;

      default:
          break;
  }
  return currentQuestion;
}
function getAnswerType(questionType, subtype) {
  let answerType = 0;
  let subQuestionLength = 0;
  if (
    questionType == constants.QUE_TYPES.COMPREHENSION ||
    questionType == constants.QUE_TYPES.TC
  ) {
    answerType = 0; // for questions with subtypes
    if (
      subtype == constants.QUE_TYPES.TC_2Q_SA ||
      subtype == constants.QUE_TYPES.COMPREHENSION_2Q_SA ||
      subtype == constants.QUE_TYPES.COMPREHENSION_2Q_MM||
      subtype == constants.QUE_TYPES.COMPREHENSION_2Q_MA || subtype == constants.QUE_TYPES.COMPREHENSION_2Q_NU
    ) {
      subQuestionLength = 2;
    } else if (
      subtype == constants.QUE_TYPES.COMPREHENSION_3Q_MA ||
      subtype == constants.QUE_TYPES.COMPREHENSION_3Q_SA ||
      subtype == constants.QUE_TYPES.TC_3Q_SA
    ) {
      subQuestionLength = 3;
    }
  } else if (
    questionType == constants.QUE_TYPES.ASSERTION_REASON ||
    questionType == constants.QUE_TYPES.MULTIPLE_CORRECT ||
    questionType == constants.QUE_TYPES.SINGLE_CORRECT ||
questionType === constants.QUE_TYPES.SINGLE_CORRECT_SEC2 
  ) {
    answerType = 1; // for questions options
  } else if (
    questionType == constants.QUE_TYPES.MATRIX_MATCH_OPTION ||
    questionType == constants.QUE_TYPES.MATRIX_MATCH
  ) {
    answerType = 2; // for questions with options, optionsabc, optionspqr
  } else if (questionType == constants.QUE_TYPES.SUBJECTIVE || questionType == constants.QUE_TYPES.SUBJECTIVEINTEGER) {
    answerType = 3; // for subjective type questions
  } else if (questionType == constants.QUE_TYPES.INTEGER) {
    answerType = 4; // for integer type questions
  }
  return {answerType,subQuestionLength};
}
function createTestData({questions,optionalQuestionsList,selectedChatersTopics},confirmation,checkDummyAnswer){
  let list = [],forUpdate=false;
  questions.map((q, i) => {
    let obj = {
      index: i+1,
      subIndex: q.subIndex,
      data_type_id: q.chapterId,
      correct_marks: q.correctMarkingSchema,
      negative_marks: q.inCorrectMarkingSchema,
      partial_marking: q.partialMarking,
      subject_id:  getSubjectId(q.subject),
      difficulty_level: q.subject.difficulty,
      required_questions: parseInt(q.required_questions),
      question_type:typeof q.questionType === 'number'?  q.questionType: q.questionType.id,
      hints: [],
      chapter_ids:selectedChatersTopics&& selectedChatersTopics[q.subject.title] ? selectedChatersTopics[q.subject.title].selectedChapters:[],
      topic_ids: selectedChatersTopics&& selectedChatersTopics[q.subject.title] ? selectedChatersTopics[q.subject.title].selectedTopics:[],
      section_id: optionalQuestionsList.length > 0 ? 2 : 1,
      subType: q.subtype || null,
      sub_subject: q.subject.code,
      l1_questions_required:q.l1_questions_required,
      l2_questions_required:q.l2_questions_required,
      l3_questions_required:q.l3_questions_required,
    };
    if (q.id) {
      obj.id = q.id;
      forUpdate = true;
    }
    if (confirmation) {
      obj.dummy_question = {
        index: i+1,
        subIndex: q.subIndex,
        question_text: q.question_text,
        question_type: q && q.questionType.id ? q.questionType.id : q.questionType,
        subType: q.subtype,
        data_type_id: q.chapterId,
        correct_marks: q.correctMarkingSchema,
        negative_marks: q.inCorrectMarkingSchema,
        partial_marking: q.partialMarking,
        questions: q.questions,
        solution: q.solution,
        section_id: optionalQuestionsList.length > 0 ? 2 : 1,
        noOfMandatoryQuestions: q.noOfMandatoryQuestions,
        hints: getHintsForRequest(q.hints),
        subject_id: getSubjectId(q.subject),
        sub_subject: q.subject.code
      };
      obj.dummy_question = setDummyAnswerAsPerType(obj.dummy_question)
      if (checkDummyAnswer) {
        
        if (
          q.questionType.id === constants.QUE_TYPES.INTEGER ||
          q.questionType.id === constants.QUE_TYPES.SUBJECTIVE ||
          q.questionType.id === constants.QUE_TYPES.SUBJECTIVEINTEGER
        ) {
          obj.dummy_question.correct_answer = q.correct_answer;
        } else {
          obj.dummy_question.correct_answer = null;
        }
        if (
          q.questionType.id === constants.QUE_TYPES.ASSERTION_REASON ||
          q.questionType.id === constants.QUE_TYPES.MULTIPLE_CORRECT ||
          q.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT
        ) {
          obj.dummy_question.options = q.options;
        } else if (q.questionType.id === constants.QUE_TYPES.MATRIX_MATCH) {
          obj.dummy_question.options = q.options_abc.concat(q.options_pqr);
        } else if (q.questionType.id === constants.QUE_TYPES.MATRIX_MATCH_OPTION) {
          obj.dummy_question.options = q.options
            .concat(q.options_abc)
            .concat(q.options_pqr);
        }
      }
    }

    list.push(obj);
  });
  return {list,forUpdate}
}
function removeSessionData(){
  localStorage.removeItem("session_start");            
  localStorage.removeItem('question');
  localStorage.removeItem('timerFlag');
  localStorage.removeItem('timeSeconds');
}

function encryptString(text){
  return CryptoJS.AES.encrypt(text,process.env.VUE_APP_ENCRYPTION_KEY);
}
function decryptString(text){
  let decryptString = CryptoJS.AES.decrypt(text, process.env.VUE_APP_ENCRYPTION_KEY);
  return decryptString.toString(CryptoJS.enc.Utf8);
}
function isAltitudeInstitute(){
  let institute = get(store, "state.myInstitute");
  return constants.CUSTOM_DOMAIN_ID.includes(institute.id)
}
function isZeroKelvinInstitute(){
  let institute = get(store, "state.myInstitute");
  return institute.id==constants.CUSTOM_DOMAIN_IDS.ZEROKELVIN
}
function getSubjectId(sub){
  if(sub.parent_id || sub.id){
    return sub.parent_id === constants.BIOLOGY_SUBJECT_ID ?sub.parent_id:sub.id
  }
  else if(sub && sub.value){
    return sub.value.parent_id === constants.BIOLOGY_SUBJECT_ID ?sub.value.parent_id:sub.value.id
  }
  else{
    return
  }
}

function checkBiology(sub){
  return sub.parent_id === constants.BIOLOGY_SUBJECT_ID 
}
function getQuestionArray(questions){
  let questionArr = [];
  let selectedQuestions = {};
  let questionTypeId;
  let subType;
  questions && questions.length && questions.map((q) => {
    if(q.subject_id === constants.BIOLOGY_SUBJECT_ID || q.subject?.parent_id === constants.BIOLOGY_SUBJECT_ID){
        questionTypeId = q.question_type || q.questionType || q.questionType.id;
        subType = q.subtype ? q.subtype : q.subType;
      if (subType) {
        if(questionTypeId && !selectedQuestions.hasOwnProperty(constants.BIOLOGY_SUBJECT_ID+'-'+questionTypeId+'-'+subType)){
          selectedQuestions[constants.BIOLOGY_SUBJECT_ID+'-'+questionTypeId+'-'+subType] = [];
        }
        selectedQuestions[constants.BIOLOGY_SUBJECT_ID+'-'+questionTypeId+'-'+subType].push(q);
      }else{
        if(questionTypeId && !selectedQuestions.hasOwnProperty(constants.BIOLOGY_SUBJECT_ID+'-'+questionTypeId)){
          selectedQuestions[constants.BIOLOGY_SUBJECT_ID+'-'+questionTypeId] = [];
        }
        selectedQuestions[constants.BIOLOGY_SUBJECT_ID+'-'+questionTypeId].push(q);
      }
    }else{
        if(!selectedQuestions.hasOwnProperty('remainingSubjects')){
          selectedQuestions['remainingSubjects'] = [];
        }
        selectedQuestions['remainingSubjects'].push(q);
      }
    })
    for (let value of Object.values(selectedQuestions)) {
      questionArr = questionArr.concat(value);
    }
    return questionArr;
}
function getMandatoryQuestions(questions) {
  let mandatoryQueArr = [];
  let newMandatoryQueObj = {};
  questions.map((q, index) => {
    if (q.questionType.id != this.QUE_TYPES.COMPREHENSION &&
      q.questionType.id != this.QUE_TYPES.TC &&
      parseInt(q.noOfMandatoryQuestions) != parseInt(q.numberOfQuestion) &&
      parseInt(q.noOfMandatoryQuestions) < parseInt(q.numberOfQuestion)) {
      let queData = questions[index];
      let subObj=queData.subject;
        newMandatoryQueObj = {
          noOfMandatoryQuestions: parseInt(queData.noOfMandatoryQuestions),
          numberOfQuestions: parseInt(queData.numberOfQuestion),
          allowAll: parseInt(queData.allow_all),
          chapterId: queData.chapterId,
          mandatoryQuestionId: null,
          questionType: queData.questionType.id,
          subject: getSubjectId(queData.subject),
          sub_subject:"null"
        }
        if(subObj && subObj.parent_id && subObj.parent_id==constants.BIOLOGY_SUBJECT_ID){
          newMandatoryQueObj.sub_subject=subObj.code;
        }
        else if(subObj.value && subObj.value.parent_id==constants.BIOLOGY_SUBJECT_ID){
          newMandatoryQueObj.sub_subject=subObj.value.code;
        }
        mandatoryQueArr.push(newMandatoryQueObj);
      }
  })
  return mandatoryQueArr;
}
const checkBoostupSubscription = () => {
  let modules = JSON.parse(localStorage.getItem("modules"));
  return modules.findIndex(m=>m.module_id === 10) >-1

}
function bytesToSize(bytes) {
  const KB = 1024;
  const MB = 1024 * KB;
 let sizeUnit = 'bytes'
  if (bytes < KB) {
      return bytes ;
  } else if (bytes < MB) {
    sizeUnit = 'KB'
      return {size:(bytes / KB).toFixed(2),sizeUnit};
  } else {
    sizeUnit = 'MB'
      return {size:(bytes / MB).toFixed(2),sizeUnit};
  }
}
async function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
      // Create a FileReader object
      const reader = new FileReader();

      // Set up FileReader onload callback
      reader.onload = function(event) {
          // Create an Image object
          const img = new Image();

          // Set up Image onload callback
          img.onload = function() {
              // Resolve the promise with the dimensions
              resolve({ width: img.width, height: img.height });
          };

          // Set up Image onerror callback
          img.onerror = function() {
              // Reject the promise if there is an error loading the image
              reject(new Error('Failed to load image'));
          };

          // Set the src attribute of the Image object to the data URL obtained from the FileReader
          img.src = event.target.result;
      };

      // Read the file as a data URL
      reader.readAsDataURL(file);
  });
}
const questionFont = (currentQuestion) =>{
return currentQuestion.question_text.includes('class="equation"')
}
const passageFont = (currentQuestion) =>{
  return currentQuestion.passage.includes('class="equation"')
}
const optionFont = (option) =>{
  return option.option_text.includes('class="equation"')
}
export default {
  generateDayWiseTimeSeries,
  computedDateFormattedMomentjs,
  allowedOnlyNumber,
  allowedOnlyNumberWithDecimal,
  renderMath,
  getInstituteLogo,
  getInstituteMobileLogo,
  checkIsDefaultInstitute,
  isCoordinator,
  checkUserType,
  setPageTitle,
  getMobileNumberWithoutCountryCode,
  getMobileNumberWithCountryCode,
  isValidMobileNumber,
  isValidEmail,
  dataURItoBlob,
  getTelegramLink,
  extractContent,
  isChecked,
  validation,
  validateAsperType,
  setRouteDetails,
  getRouteDetails,
  getCurrentRouteDetails,
  serializeObject,
  updateCurrentPageInSession,
  isCorrect,
  getHeight,
  convertMS,
  checkStudentUpgradedHelper,
  delayTime,
  setEventBeforeUpgrade,
  compareEvent,
  removeEvent,
  removeWhiteSpacesFromEmail,
  getHintsForRequest,
  createRetryQuestionData,
  setDummyAnswerAsPerType,
  createTestData,
  removeSessionData,
  encryptString,
  decryptString,
  isAltitudeInstitute,
  getSubjectId,
  checkBiology,
  getQuestionArray,
  getMandatoryQuestions,
  isZeroKelvinInstitute,
  setDivHeight,
  checkBoostupSubscription,
  bytesToSize,
  getImageDimensions,
  questionFont,
  passageFont,optionFont
};
